module.exports = __webpack_public_path__ + "static/media/2.3afb2538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/2.jpg
// module id = 1734
// module chunks = 0